var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$env.isProd)?_c('v-alert',{staticClass:"stg-alert",attrs:{"type":"error","dense":""}},[(_vm.$env.isStg)?[_vm._v("ステージング環境")]:(_vm.$env.isDev)?[_vm._v("開発環境")]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }